import { supabase } from '../supabaseClient';

/**
 * Authenticated Fetch Helper:
 * Automatically retrieves the logged-in administrator's active Supabase session
 * and injects the Bearer JWT token into the request Authorization header.
 */
export const authFetch = async (url, options = {}) => {
    try {
        const { data: { session } } = await supabase.auth.getSession();
        const token = session?.access_token;

        const headers = {
            'Content-Type': 'application/json',
            ...(options.headers || {})
        };

        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        return fetch(url, {
            ...options,
            headers
        });
    } catch (err) {
        console.error('[authFetch] Error attaching authentication session:', err);
        return fetch(url, options);
    }
};

export default authFetch;
